<template>
  <div>
    <px-view-header title="Cadastro de oferta" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div v-if="!loading">
<!--      <v-row dense class="text-right">-->
<!--        <v-col cols="12">-->
<!--          <v-btn text x-small :disabled="true">-->
<!--            <v-icon x-small>mdi-eye</v-icon>-->
<!--            Pré-Visualizar-->
<!--          </v-btn>-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-row dense>
        <v-col cols="12" sm="4">
          <v-switch
            hide-details
            class="switch-dense"
            v-model="oferta.ativo"
            label="Oferta ativa"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="4">
          <v-switch
            hide-details
            class="switch-dense"
            v-model="oferta.disponivel"
            label="Disponível"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="4">
          <v-switch
            hide-details
            class="switch-dense"
            v-model="oferta.destaque"
            label="Destacar oferta"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-autocomplete-catalogo
            required
            show-details
            :error="$v.oferta.catalogo.$error"
            @blur="$v.oferta.catalogo.$touch()"
            v-model="oferta.catalogo"
            class="required"
            @change="onChangeProduto"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="8">
          <px-autocomplete-produto
            required
            show-details
            default-empty-code="S/N"
            :only-cotavel="false"
            :clearable="false"
            :error="$v.oferta.produto.$error"
            @blur="$v.oferta.produto.$touch()"
            v-model="oferta.produto"
            class="required"
            base-path="/fornecedor/produtos"
            @change="onChangeProduto"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-autocomplete-unidade-medida required
                                          class="required"
                                          :error="$v.oferta.unidadeMedida.$error"
                                          @blur="$v.oferta.unidadeMedida.$touch()"
                                          v-model="oferta.unidadeMedida"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="8">
          <v-text-field
            outlined
            hide-details
            class="required"
            autocomplete="off"
            label="Título"
            :error="$v.oferta.titulo.$error"
            @blur="$v.oferta.titulo.$touch()"
            v-model="oferta.titulo"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            outlined
            hide-details
            class="required"
            maxlength="20"
            autocomplete="off"
            label="Código"
            append-icon="mdi-refresh"
            :disabled="editing"
            :error="$v.oferta.codigo.$error"
            @blur="$v.oferta.codigo.$touch()"
            v-model="oferta.codigo"
            @click:append="onGenerateCode"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3">
          <px-input-money
            ref="precoPraticado"
            class="required"
            label="Preço original"
            :error="$v.oferta.precoOriginal.$error"
            @blur="$v.oferta.precoOriginal.$touch()"
            v-model="oferta.precoOriginal"/>
        </v-col>
        <v-col cols="12" sm="3">
          <px-input-money
            ref="precoPraticado"
            class="required"
            label="Preço à vista"
            :error="$v.oferta.precoAVista.$error"
            @blur="$v.oferta.precoAVista.$touch()"
            v-model="oferta.precoAVista"/>
        </v-col>
        <v-col cols="12" sm="3">
          <px-input-money
            ref="precoPraticado"
            class="required"
            label="Preço a prazo"
            :error="$v.oferta.precoAPrazo.$error"
            @blur="$v.oferta.precoAPrazo.$touch()"
            v-model="oferta.precoAPrazo"/>
        </v-col>
        <v-col cols="12" sm="3">
          <px-input-number :label="`Quantidade mínima (em ${unidadeDescricao})`"
                           required
                           class="required"
                           :error="$v.oferta.quantidade.$error"
                           @blur="$v.oferta.quantidade.$touch()"
                           v-model="oferta.quantidade"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="required"
            label="Especificação da oferta"
            counter="4000"
            rows="3"
            :error="$v.oferta.especificacao.$error"
            @blur="$v.oferta.especificacao.$touch()"
            v-model="oferta.especificacao"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn color="primary"
                 @click="save"
                 :loading="loadingSave">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { TipoFrete } from 'px-business-components';
import { NumberUtils } from 'px-components';
import { generateUpperString } from '@/utils/generate-string-utils';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import OfertaService from '../oferta-service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingSave: false,
      breadcrumbs: [
        { text: 'Catálogo' },
        { text: 'Ofertas' },
        { text: 'Cadastro de oferta' },
      ],
      tiposFrete: TipoFrete.values,
      id: this.$route.params.id,
      oferta: {
        titulo: null,
        codigo: null,
        fornecedor: null,
        especificacao: null,
        catalogo: null,
        produto: null,
        unidadeMedida: null,
        precoOriginal: null,
        precoAVista: null,
        precoAPrazo: null,
        quantidade: null,
        ativo: true,
        disponivel: true,
        destaque: false,
      },
    };
  },
  computed: {
    unidadeDescricao() {
      if (!this.oferta.unidadeMedida) {
        return 'un';
      }
      return this.oferta.unidadeMedida.descricao;
    },
    isFob() {
      return this.oferta.tipoFrete === TipoFrete.keys.FOB.key;
    },
    editing() {
      return !!this.id;
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.ofertas' });
    },
    onChangeProduto() {
      if (!this.oferta.produto) {
        return;
      }
      this.oferta.titulo = this.oferta.produto.descricao;
      this.oferta.especificacao = this.oferta.produto.especificacao;
      this.oferta.unidadeMedida = this.oferta.produto.unidadeMedida;
    },
    onGenerateCode() {
      this.oferta.codigo = generateUpperString(15);
    },
    buildOferta() {
      const oferta = cloneDeep(this.oferta);
      oferta.titulo = this.oferta.titulo.toUpperCase();
      return oferta;
    },
    save() {
      if (this.validateForm()) {
        return;
      }
      this.loadingSave = true;
      OfertaService.save(this.buildOferta())
        .then(() => {
          this.$toast('Oferta salva com sucesso', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    setupEditingObject() {
      this.oferta.precoOriginal = NumberUtils.fixNumberInput(this.oferta.precoOriginal);
      this.oferta.precoAVista = NumberUtils.fixNumberInput(this.oferta.precoAVista);
      this.oferta.precoAPrazo = NumberUtils.fixNumberInput(this.oferta.precoAPrazo);
    },
    getOferta() {
      this.loading = true;
      OfertaService.get(this.id)
        .then(({ data }) => {
          this.oferta = data;
          this.setupEditingObject();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setupEditing() {
      this.getOferta();
    },
  },
  created() {
    if (this.editing) {
      this.setupEditing();
      return;
    }
    this.onGenerateCode();
  },
  validations: {
    oferta: {
      catalogo: {
        required,
      },
      produto: {
        required,
      },
      unidadeMedida: {
        required,
      },
      titulo: {
        required,
      },
      especificacao: {
        required,
      },
      codigo: {
        required,
      },
      precoOriginal: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
      precoAVista: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
      precoAPrazo: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
      quantidade: {
        required,
        minValue(value) {
          return value > 0;
        },
      },
    },
  },
};
</script>
